import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messagesRus from 'src/localization/ru';
import messagesEng from 'src/localization/en';

function getLocale() {
  return { ...messagesRus, ...messagesEng };
}

const lang = 'ru';

Vue.use(VueI18n);
const messages = getLocale();

export default new VueI18n({
  locale: lang,
  messages,
});
